/** Brand id string for API from react-select value or stored id. */
export function resolveBrandName(brand) {
    if (brand == null) return "";
    if (typeof brand === "object") {
        const id = brand.value ?? brand.id;
        return id != null && id !== "" ? String(id) : "";
    }
    return String(brand);
}

export function matchCategoryOption(categories, data) {
    if (!data) return null;

    const categoryId = data.category_id;
    if (categoryId != null && categoryId !== "" && categories?.length) {
        const found = categories.find(
            (c) =>
                String(c.id) === String(categoryId) ||
                String(c.value) === String(categoryId)
        );
        if (found) return found;
    }

    if (data.category_details) {
        const id = data.category_details.id ?? categoryId;
        const label = data.category_details.category || data.category;
        if (label) {
            return { label, value: id, id };
        }
    }

    if (data.category && categoryId != null && categoryId !== "") {
        return { label: data.category, value: categoryId, id: categoryId };
    }

    return null;
}

export function matchBrandOption(brands, data) {
    if (!data) return null;

    const brandId = data.brand_name;
    if (brandId != null && brandId !== "" && brands?.length) {
        const found = brands.find(
            (b) =>
                String(b.value) === String(brandId) ||
                String(b.id) === String(brandId)
        );
        if (found) return found;
    }

    if (data.brand_details?.name) {
        const id = data.brand_details.id ?? brandId;
        return { label: data.brand_details.name, value: id, id };
    }

    return null;
}

/** Keep a user pick; only replace placeholder/empty values when lists load. */
export function preserveSelectOption(current, matched) {
    if (current?.label && current.label !== "Unknown") {
        return current;
    }
    return matched ?? current ?? null;
}
